import Input from 'client/core/Input';

export default class InputHidden extends Input {
    validate () {
        return true;
    }
}
